/* Default is nav as Dialog; grab all the DOM bits we care about... */
const showSiteNavigationButton = document.querySelector('#showSiteNavigation');
const siteNavigationDialog     = document.querySelector('#siteNavigationDialog');
const headerContainer          = document.querySelector('header > .container');
const rowMainNavigation        = document.querySelector('#site_navigation');
// const rowPromotedNavigation    = siteNavigationDialog.querySelector('.rowPromotedNavigation');

/* Make the dialog open when we click the menu button */
showSiteNavigationButton.addEventListener('click', () => {
	siteNavigationDialog.showModal();
});

/* Functions to move DOM nodes around */
function moveIntoDialog() {
	siteNavigationDialog.appendChild( rowMainNavigation );
	// siteNavigationDialog.appendChild( rowPromotedNavigation );
}
function moveOutOfDialog() {
	headerContainer.appendChild( rowMainNavigation );
	// headerContainer.appendChild( rowPromotedNavigation );
}

/* Where do we want DOM nodes given the current screen size? */
let screenWidth = window.matchMedia('(max-width: 1259px)');
if( screenWidth.matches ) { moveIntoDialog(); }
else { moveOutOfDialog(); }

/* Watch for changes and apply as needed */
screenWidth.addEventListener("change", (e) => {
	if( e.matches ) { moveIntoDialog(); }
	else { moveOutOfDialog(); }
});